const gl0 = document.createElement("canvas").getContext("webgl");
const gl1 = document.createElement("canvas").getContext("experimental-webgl");
const gl2 = document.createElement("canvas").getContext("webgl2");

export function getExtentions() {
  return {
    ext1: gl0.getSupportedExtensions(),
    ext2: gl1.getSupportedExtensions(),
    ext3: gl2.getSupportedExtensions(),
  };
}

function hasWebgl2() {
  return Boolean(gl2);
}

export default hasWebgl2;
